import useTranslation from 'next-translate/useTranslation';
import PropTypes from 'prop-types';

import Button from '@/components/Button/Button';
import Text from '@/components/Text';
import { useFastSignUp } from '@/hooks';
import FastSignUpForm from '@/widgets/ReconciliationCustomer/Form';

const Consultation = ({ setCurrentPage }) => {
  const { t: h } = useTranslation('page-auth');
  const consultation = h('Consultation', {}, { returnObjects: true });
  const { mutateAsync, isError } = useFastSignUp();
  return (
    <>
      <Text mb={['2.5rem', '2.5rem', '2.5rem']} variant="headlineGrey">
        {h('title')}
      </Text>
      <Text variant="capsTitle">{consultation.step}</Text>
      <Text variant="bodyLightSmallNativ">{consultation.text}</Text>
      <Text variant="bodyLightSmallNativ">{consultation.terms}</Text>
      <FastSignUpForm onSubmit={mutateAsync} isError={isError} />
      <Button
        mb={[0, 0, 0]}
        mt={['2.831rem', '2.831rem', '2.831rem']}
        onClick={setCurrentPage('ConsultationQuery')}
        variant="secondary"
        width={['100%', '100%', '100%']}
      >
        {consultation.buttonBack}
      </Button>
    </>
  );
};

Consultation.propTypes = {
  setCurrentPage: PropTypes.string.isRequired,
};
export default Consultation;
